<!--
The Vue app. <router-view /> includes view components from router.js.
Global components are registered and included here.
@author bmk11u
-->
<template>
  <div  class="container px-0">
    <router-view></router-view>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { getAction } from '@/mixins/CustomUrls.js'
import { useRouter } from 'vue-router'

const router = useRouter()

/* switched this over to using Vue 3's Composition API.

As per note in FooterMenu we're not converting EVERYTHING over just yet. */

onMounted(() => {
  console.log('* APP.VUE MOUNTED EVENT FIRED *')
  insertClarity(window, document, 'clarity', 'script', 'gvied9ztsv')
  // let _this = this
  // let hgu = handleGivenUrl // TODO do we need to do the _this-this thing anymore?
  window.handleOpenURL = function (url) {
    handleGivenUrl(url)
    // hgu(url)
  }
})

function handleGivenUrl (url) {
  // const url = event.detail.givenUrl
  console.log(' --> we got launched from URL: ' + url)
  const action = getAction(url)
  console.log(JSON.stringify(action))
  if (action.action === 'booking') {
    // test
    router.push({
      path: 'findaspace',
      query: {
        src: action.params.src,
        roomId: action.params.roomId
      }
    })
  }
}

function insertClarity (c, l, a, r, i, t, y) {
  c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) }
  t = l.createElement(r); t.async = 1; t.src = 'https://www.clarity.ms/tag/' + i
  y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y)
}

</script>
<style>
div#app {
  width: 100%;
  min-height: 100vh;
}
</style>
